import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { authService } from '../../services/auth.service';

interface RoleGuardProps {
  allowedRoles: string[];
}

const RoleGuard: React.FC<RoleGuardProps> = ({ allowedRoles }) => {
  const location = useLocation();
  const role = authService.getRole();

  if (!allowedRoles.includes(role)) {
    return <Navigate to="/niet-toegestaan" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default RoleGuard;
